<div class="container-fluid paddingright">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">View Tracker Invoice</h1>
        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>

      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item active" aria-current="page">
            Manage Tracker
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            View Tracker Invoice
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <!-- ================= FILTER FORM ================= -->
  <div class="contentbox w-90vw mt-3">
    <form [formGroup]="filterform">
      <div class="row">
        <!-- Company -->
        <div class="col-md-4">
          <div class="form-group accountsinp mb-3">
            <label>Company Name</label>
            <select
              id="clientNamectrl"
              formControlName="clientName"
              class="form-control shadow-none"
              (change)="onClientChange($event)"
            >
              <option value="">--Select Company Name--</option>
              <option *ngFor="let c of clientList" [value]="c._id">
                {{ c.clientName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Tracker No -->
        <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
          <label>Tracker No.<sup class="text-danger">*</sup></label>
          <div class="form-group accountsinp mb-3">
            <ng-multiselect-dropdown
              formControlName="Tracker_no"
              [placeholder]="'Select Tracker No.'"
              [settings]="dropdownSettings"
              [data]="trackerNumber"
            >
            </ng-multiselect-dropdown>
          </div>
        </div>

        <!-- Invoice Type -->
        <div class="col-md-4">
          <div class="form-group accountsinp mb-3">
            <label>Invoice Type</label>
            <select
              id="invoiceTypectrl"
              formControlName="invoiceType"
              class="form-control shadow-none"
            >
              <option value="">--Select Invoice Type--</option>
              <option *ngFor="let s of invoiceType" [value]="s.invoiceTypeName">
                {{ s.invoiceTypeName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Generate Button -->
        <div class="col-xl-12 text-end">
          <button
            class="btn btn-dark ms-2"
            type="submit"
            mat-raised-button
            (click)="generateTrackerInvoice()"
          >
            Invoice Generate
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- ================= TABLE ================= -->
  <div class="contentbox w-90vw mt-3">
    <div class="row">
      <div class="col-xl-3 ms-auto">
        <input
          class="search-box form-control"
          placeholder="Search"
          type="text"
          (keyup)="filterData($event.target.value)"
        />
      </div>

      <div class="col-md-12">
        <div class="table-responsive">
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="created_date"
            matSortDirection="desc"
            class="row-border hover tablelist"
          >
            <!-- S.No -->
            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef>S.no</th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{ paginator.pageIndex * paginator.pageSize + (i + 1) }}
              </td>
            </ng-container>

            <!-- Company -->
            <ng-container matColumnDef="clientName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Company Name
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row?.clientName }}
              </td>
            </ng-container>

            <!-- Date -->
            <ng-container matColumnDef="created_date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
              <td mat-cell *matCellDef="let row">
                {{ row.created_date | date : "yyyy-MM-dd" }}
              </td>
            </ng-container>

            <!-- Action -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Action
              </th>
              <td mat-cell *matCellDef="let row">
                <div class="d-flex justify-content-center align-items-center">
                  <button
                    class="btn btn-block"
                    (click)="viewTrackerInvoice(row._id)"
                  >
                    <i matTooltip="View" class="fa-solid fa-eye"></i>
                  </button>
                  <button
                    (click)="getParticularInvoice(row._id)"
                    class="btn btn-block"
                  >
                    <i matTooltip="Print" class="fas fa-print"></i>
                  </button>
                  <button
                    #printBtn
                    ngxPrint
                    printSectionId="print-section"
                    style="display: none"
                  ></button>

                  <button
                    class="btn btn-block"
                    (click)="sendInvoice('print-section', row._id)"
                  >
                    <i matTooltip="Send" class="fa fa-paper-plane"></i>
                  </button>

                  <button
                    class="btn btn-block"
                    (click)="deleteTrackerInvoice(row._id)"
                  >
                    <i matTooltip="Delete" class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <mat-paginator
            #paginator
            [length]="100"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>

  <!-- ================= PRINT SECTION (Hidden) - Professional Layout ================= -->
  <div #printSection id="print-section" style="display: none;">
    <div style="padding: 20px 30px; font-family: Arial, Helvetica, sans-serif; width: 210mm; min-height: 297mm; background: white; box-sizing: border-box; margin: 0 auto;">
      
      <!-- Header with Logo & Transporter -->
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
        <tr>
          <td style="width: 60%; vertical-align: top; padding: 10px 0;">
            <table style="width: 100%;">
              <tr>
                <td style="font-size: 14px; font-weight: bold;">Transporter Name</td>
                <td style="font-size: 14px;">: K LOGISTICS</td>
              </tr>
            </table>
          </td>
          <!-- <td style="width: 10%; text-align: right; padding: 10px 0;">
            <img 
              src="../../../../assets/images/rsts-logo.png" 
              alt="Company Logo" 
              style="max-width: 200px; height: auto;"
            />
          </td> -->
        </tr>
      </table>

      <!-- Invoice Title -->
      <h2 style="text-align: center; margin: 15px 0; font-size: 22px; color: #333;">Tracker Invoice</h2>

      <!-- Main Invoice Table -->
      <table style="width: 100%; border-collapse: collapse; font-size: 12px;" border="1">
        <thead>
          <tr style="background-color: #f2f2f2; font-weight: bold; text-align: center;">
            <th style="padding: 8px; border: 1px solid #ddd;">Date</th>
            <th style="padding: 8px; border: 1px solid #ddd;">Tracker No.</th>
            <th style="padding: 8px; border: 1px solid #ddd;">VEHICLE NO</th>
            <th style="padding: 8px; border: 1px solid #ddd;">From</th>
            <th style="padding: 8px; border: 1px solid #ddd;">To</th>
            <th style="padding: 8px; border: 1px solid #ddd;">START READING</th>
            <th style="padding: 8px; border: 1px solid #ddd;">END READING</th>
            <th style="padding: 8px; border: 1px solid #ddd;">KMR.</th>
            <th style="padding: 8px; border: 1px solid #ddd;">EXTRA HRS</th>
            <th style="padding: 8px; border: 1px solid #ddd;">Toll & Parking</th>
            <th style="padding: 8px; border: 1px solid #ddd;">AMOUNT</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngIf="users?.length > 0">
            <ng-container *ngFor="let user of users">
              <ng-container *ngFor="let tracker of user.Tracker_no; let i = index">
                <tr>
                  <td style="padding: 6px; text-align: center;">{{ user.date?.[i] | date:'dd-MM-yyyy' }}</td>
                  <td style="padding: 6px; text-align: center;">{{ user.Tracker_no?.[i] }}</td>
                  <td style="padding: 6px; text-align: center;">{{ user.vehicle_id?.[i] }}</td>
                  <td style="padding: 6px;">{{ user.from?.[i] }}</td>
                  <td style="padding: 6px;">{{ user.to?.[i] }}</td>
                  <td style="padding: 6px; text-align: center;">{{ user.startmeterReading?.[i] }}</td>
                  <td style="padding: 6px; text-align: center;">{{ user.endmeterReading?.[i] }}</td>
                  <td style="padding: 6px; text-align: center;">{{ user.up_down_km?.[i] }}</td>
                  <td style="padding: 6px; text-align: center;">{{ user.extrahour?.[i] }}</td>
                  <td style="padding: 6px; text-align: center;">{{ user.tooltaxPaid?.[i] }}</td>
                  <td style="padding: 6px; text-align: right;">{{ user.vehicleRate?.[i] | number:'1.2-2' }}</td>
                </tr>
              </ng-container>
            </ng-container>

            <!-- Grand Total Row -->
            <tr style="font-weight: bold; background-color: #f9f9f9;">
              <td colspan="7" style="padding: 8px; text-align: right;">TOTAL</td>
              <td style="padding: 8px; text-align: center;">{{ kmtot | number:'1.2-2' }}</td>
              <td style="padding: 8px; text-align: center;">{{ extrahour | number:'1.2-2' }}</td>
              <td style="padding: 8px; text-align: center;">{{ tooltaxPaidtot | number:'1.2-2' }}</td>
              <td style="padding: 8px; text-align: right;">{{ invtot | number:'1.2-2' }}</td>
            </tr>
          </ng-container>

          <tr *ngIf="!users?.length">
            <td colspan="11" style="padding: 20px; text-align: center; color: #777;">
              No invoice data available
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Summary & Amount in Words -->
      <div style="margin-top: 20px; display: flex; justify-content: space-between; font-size: 13px;">
        <div style="width: 50%;">
          <strong>In Words:</strong> {{ invtot | amountInWords }}
        </div>
        <div style="width: 50%; text-align: right;">
          <table style="width: 100%; font-size: 13px;">
            <tr><td>Total KM</td><td>: {{ kmtot | number:'1.2-2' }}</td></tr>
            <tr><td>Extra Hours</td><td>: {{ extrahour | number:'1.2-2' }}</td></tr>
            <tr><td>Toll & Parking</td><td>: {{ tooltaxPaidtot | number:'1.2-2' }}</td></tr>
            <tr style="font-weight: bold;"><td>Total Amount</td><td>: {{ invtot | number:'1.2-2' }}</td></tr>
          </table>
        </div>
      </div>

      <!-- Confirmation Text -->
      <p style="margin-top: 30px; font-size: 13px; font-style: italic; text-align: center;">
        We hereby confirm that all tracker entries duly acknowledged by the customer have been received and the above details are correct.
      </p>

      <!-- Signature Section -->
      <table style="width: 100%; margin-top: 50px; font-size: 13px;">
        <tr>
          <td style="width: 33%; text-align: center;">
            Prepared By<br><br>___________________<br>Name & Designation
          </td>
          <td style="width: 33%; text-align: center;">
            Verified By<br><br>___________________<br>Name & Designation
          </td>
          <td style="width: 33%; text-align: center;">
            Approved By<br><br>___________________<br>Name & Designation
          </td>
        </tr>
      </table>
    </div>
  </div>

  <!-- ================= SPINNER ================= -->
  <ngx-spinner
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-scale-multiple"
  >
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</div>